import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    PatientNextButton: {
        display: "flex",
        flexDirection: "column",
        marginTop: 50,
        justifyContent: "center",
        alignContent:'center',
        //marginBottom:100
    },
    createAccountButton: {
        height: 74,
        width: "534px",
        borderRadius: 10,
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 200,
        fontSize: 24,
        color: "#FFFFFF",
        textTransform: "none",
    },
    mainTitle: {
        textAlign: "left",
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 20,
        display: "flex",
        justifyContent: "space-between",
        color: "#000000",
    },
    backArrow: {
        fontFamily: 'Manrope',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 24,
        display: "flex",
        alignItems: "center",
        color: "#024C9C",
        textDecoration: "none",
    },
    iconchild: {
        color: "#024C9C",
        fontSize: 18,
        marginRight: 5,
    },
}));